import security from '../../../utils/security'
import http from '../../../utils/http'
import {
  AGREEMENT_INVOICE_LOADING,
  AGREEMENT_INVOICE_SUCCESS,
  AGREEMENT_INVOICE_ERROR,
  AGREEMENT_INVOICE_RESET
} from './mutation-types'

const state = {
  loading: false,
  error: '',
  items: []
}

function error (error) {
  return {type: AGREEMENT_INVOICE_ERROR, error}
}

function loading (loading) {
  return {type: AGREEMENT_INVOICE_LOADING, loading}
}

function success (items) {
  return {type: AGREEMENT_INVOICE_SUCCESS, items}
}

function reset () {
  return {type: AGREEMENT_INVOICE_RESET}
}

const getters = {
  error: state => state.error,
  items: state => state.items,
  loading: state => state.loading,
}

const actions = {
  getItems ({commit}, agreementId) {
    commit(loading(true))
    commit(error(null))
    const page = '/agreements/' + agreementId + '/factored_invoices?order[createdAt]=DESC'

    return http.fetch(page)
      .then(response => {
        commit(loading(false))
        return response.json()
      })
      .then(data => {
        commit(success(data['hydra:member']))
      })
      .catch(e => {
        commit(loading(false))
        if (security.handleAuthorizationError(e)) {
          return
        }
        commit(error(e.message))
      })
  },
  reset({ commit }) {
    commit(reset());
  }
}

const mutations = {
  [AGREEMENT_INVOICE_ERROR] (state, payload) {
    state.error = payload.error
  },
  [AGREEMENT_INVOICE_LOADING] (state, payload) {
    state.loading = payload.loading
  },
  [AGREEMENT_INVOICE_SUCCESS] (state, payload) {
    state.items = payload.items
  },
  [AGREEMENT_INVOICE_RESET] (state) {
    state.items = [];
    state.loading= false,
    state.error = '';
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/agreement/invoice-list.js